/* eslint-disable no-console */
import React, { useState } from 'react';
import { Box, Modal, Button, Grid, Tooltip, IconButton, TextField, Avatar, Typography, Container, InputAdornment } from '@mui/material';
import Draggable from 'react-draggable';
import CloseIcon from '@mui/icons-material/Close';
import { notification } from 'antd';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { adminLoginPath1 } from '../../shared/assets/images';
import AdminModal from './Admin_modal';
import { decrypt_data } from '../../shared/utils';
import { user1_email, user2_email, user3_email, user4_email } from '../../shared/constantVariable';
import './adminLogin.scss';

const AdminLogin = (props) => {
  const { adminLoginOption, handleCloseOption } = props;
  const [adminOption, setAdminOption] = useState(false);

  const userId = sessionStorage.getItem('user_email');
  const userName = sessionStorage.getItem('user_name');

  const [adminUserId, setAdminUserId] = useState(userId);

  const [, contextHolder] = notification.useNotification();

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = () => setShowPassword((show) => !show);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const credential = {
      email: data.get('email'),
      password: data.get('password'),
    };

    const admin_pwd_enc = process.env.REACT_APP_ADMIN_PWD;
    const admin_pwd = decrypt_data(admin_pwd_enc);

    const resDictionary = [
      {
        employee_email: user1_email,
        authentication_pwd: 'a'
      },
      {
        employee_email: user2_email,
        authentication_pwd: admin_pwd
      },
      {
        employee_email: user3_email,
        authentication_pwd: admin_pwd
      },
      {
        employee_email: user4_email,
        authentication_pwd: admin_pwd
      }
    ];
    let isAuthorised = false;
    // replace resDictionary with adminUserCredentials  in below line
    resDictionary.find((emp) => {   // adminUserCredentials resDictionary
      if (emp.employee_email === credential.email) {
        if (emp.authentication_pwd === credential.password) {
          isAuthorised = true;
          return emp;
        }
      }
    });
    if (isAuthorised) { //  login success
      setAdminOption(true);
    }
    else {
      notification.error({
        message: 'Login Failed',
        description: 'Please enter the valid username and password.',
        closable: false,
        icon: null
      });
    }
  };

  return (
    <>
      {contextHolder}
      <Draggable handle='.admin-header-grid' cancel='.admin-close-icon'>
        <Modal
          hideBackdrop  //  prevent closing modal when clicked outside
          open={adminLoginOption}
          onClose={handleCloseOption}
          aria-labelledby='child-modal-title'
          aria-describedby='child-modal-description'
          className='admin-modal'
        >
          <Box className='adminLog-box'>
            <Grid container className='admin-grid-container'>
              <Grid item xs={12} className='admin-header-grid'>
                <div className='admin-header-text' >
                  Admin Login
                </div>
                <div className='admin-close-icon'>
                  <Tooltip title='Close'>
                    <IconButton
                      aria-label='save'
                      onClick={handleCloseOption}
                      size='large'
                      className='close-icon'
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </Grid>
              <Grid item xs={12} >
                <img src={adminLoginPath1} alt="adminLoginPath" style={{
                  'position': 'relative',
                  'width': '100%', height: '25%'
                }} />
                <Avatar sx={{
                  'position': 'absolute', m: 0, bgcolor: 'secondary.main', 'left': '41%', 'top': '21%',
                  'backgroundColor': 'grey', 'border': '6px solid white', 'width': '60px', 'height': '60px'
                }}>
                  {userName ? userName.split(' ').map(item => item.split('')[0]).join('').toUpperCase() : 'U'}
                </Avatar>
                <Container component='main' maxWidth='xs'>
                  <Box
                    sx={{
                      marginTop: 3,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <Typography component='h1' variant='h5' sx={{ 'fontFamily': 'sans W4SeLig' }}>
                      <p>Welcome <strong>{userName.split(' ')[0]}</strong></p>
                    </Typography>
                    <div className='adminLoginSubText'>Enter your credentials and password to proceed</div>
                    <Box component='form' onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                      <div className='adminLoginEmail '>
                        <span className='adminLoginFeild'>Email Id*</span>
                        <TextField
                          margin='normal'
                          fullWidth
                          id='email'
                          name='email'
                          variant="outlined"
                          className="admin-input-props"
                          value={adminUserId}
                          onChange={(e) => setAdminUserId(e.target.value)}
                        />
                      </div>
                      <div className='adminLoginPwd mt-2'>
                        <span className='adminLoginFeild'>Password*</span>
                        <TextField
                          margin='normal'
                          fullWidth
                          name='password'
                          type={showPassword ? 'text' : 'password'}
                          id='password'
                          autoFocus
                          variant="outlined"
                          className="admin-input-props"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position='end'>
                                <IconButton
                                  aria-label='toggle password visibility'
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                >
                                  {showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                        />
                      </div>

                      <Button
                        type='submit'
                        fullWidth
                        variant='contained'
                        className='adminLoginButton '
                        sx={{ mt: 3, mb: 2, backgroundColor: '#00AEC7' }}
                      >
                        LogIn
                      </Button>
                    </Box>
                  </Box>
                </Container>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </Draggable>
      {adminOption && (
        <AdminModal
          adminOption={adminOption}
          handleCloseOption={handleCloseOption}
        />
      )}
    </>
  );
};
export default React.memo(AdminLogin);
// Winflows@5.0